import React from "react";

import ProductSummaryItem from "../ProductSummaryItem";
import NumberInput from "../../../../atoms/Forms/NumberInput";
import Icon from '../../../../atoms/Icon/icon';
import useWindowSize from "hooks/useWindowSize";
import styles from "./ProductAddedItem.module.scss";

const ProductAddedItem = ({
  product,
  stock,
  units,
  handleEdit,
  handleDelete,
  subtitle,
  trashIcon
}) => {
  const { isMobile } = useWindowSize();

  return (
    <div className={styles["product-added-item-container"]} key={product.id}>
      <div className={styles["product-added-item-wrapper"]}>
        <ProductSummaryItem
          product={product}
          units={units}
          add={true}
          stock={stock}
          subtitle={subtitle}
        />
        <div className={styles["product-added-item-right-col"]}>
          <div className={styles["product-added-item-number-input"]}>
            <NumberInput
              value={units}
              name="quantity"
              handleChange={handleEdit}
              id={product.id}
              disabled={!stock || stock == 0}
            />
          </div>
          <div
            className={styles["product-added-item-delete"]}
            onClick={() => handleDelete(product.id)}
          >
            {trashIcon ? (
              trashIcon
            ) : (
              <Icon
                name="trash_can"
                fill={"#3C7AF5"}
                width={isMobile ? 12 : 14}
                height={isMobile ? 14 : 16}
              />
            )}
          </div>
        </div>
      </div>

      <div className={styles["product-added-item-divider"]}></div>
    </div>
  );
};

export default ProductAddedItem;
